import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { CONTACT } from "@/lib/contacts";

const FloatingWhatsApp = ({ pushedUp = false }) => {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShow(true), 1200);
    const t2 = setTimeout(() => setExpand(true), 2600);
    const t3 = setTimeout(() => setExpand(false), 8000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  if (!show) return null;

  return (
    <aside
      aria-label={t.floating.label}
      className={`fixed z-40 left-5 md:left-7 flex items-end gap-3 transition-[bottom] duration-300 ${
        pushedUp ? "bottom-24 lg:bottom-7" : "bottom-5 md:bottom-7"
      }`}
      data-testid="floating-whatsapp"
    >
      {expand && (
        <div className="relative max-w-[260px] rounded-2xl bg-white text-black px-4 py-3 pr-7 shadow-2xl">
          <button
            type="button"
            onClick={() => setExpand(false)}
            className="absolute top-1.5 right-1.5 inline-flex h-5 w-5 items-center justify-center rounded-full hover:bg-black/10"
            data-testid="floating-whatsapp-close"
            aria-label={t.a11y.close}
          >
            <X className="h-3 w-3" aria-hidden="true" />
          </button>
          <p className="font-heading text-sm font-bold">AIOTrade Admin</p>
          <p className="text-xs text-zinc-700 leading-snug mt-0.5">
            {t.floating.label} · {CONTACT.whatsappDisplay}
          </p>
        </div>
      )}

      <a
        href={CONTACT.whatsappAdmin}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="wa-pulse group inline-flex items-center gap-3 px-4 md:px-5 h-14 md:h-16 rounded-full bg-[#25D366] text-black font-bold text-sm md:text-base hover:bg-[#1ebe5b] transition-colors"
        aria-label={`${t.floating.label} WhatsApp ${CONTACT.whatsappDisplay} ${t.a11y.external}`}
      >
        <MessageCircle className="h-6 w-6 md:h-7 md:w-7" strokeWidth={2.2} aria-hidden="true" />
        <span className="hidden sm:inline" aria-hidden="true">
          {t.floating.label}
        </span>
      </a>
    </aside>
  );
};

export default FloatingWhatsApp;
